"use client";

import { useState } from "react";
import { Box, Typography, IconButton, Button } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

const Calendar = ({
  currentDate,
  selectedDate,
  setSelectedDate,
  setCurrentDate,
  onSelectDate,
}) => {
  const monthNames = [
    "Січень",
    "Лютий",
    "Березень",
    "Квітень",
    "Травень",
    "Червень",
    "Липень",
    "Серпень",
    "Вересень",
    "Жовтень",
    "Листопад",
    "Грудень",
  ];

  const dayNames = ["ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ", "НД"];

  const getDaysInMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  };

  const getFirstDayOfMonth = (date) => {
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1).getDay();
    return firstDay === 0 ? 6 : firstDay - 1;
  };

  const navigateMonth = (direction) => {
    setCurrentDate((prev) => {
      const newDate = new Date(prev);
      if (direction === "prev") {
        newDate.setMonth(prev.getMonth() - 1);
      } else {
        newDate.setMonth(prev.getMonth() + 1);
      }
      setSelectedDate(1);
      return newDate;
    });
  };

  const renderCalendarDays = () => {
    const daysInMonth = getDaysInMonth(currentDate);
    const firstDay = getFirstDayOfMonth(currentDate);
    const days = [];
    for (let i = 0; i < firstDay; i++) {
      days.push(
        <Box
          key={`empty-${i}`}
          sx={{
            width: "14.28%",
            height: 40,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        />
      );
    }
    for (let day = 1; day <= daysInMonth; day++) {
      const isSelected = day === selectedDate;
      days.push(
        <Box
          key={day}
          sx={{
            width: "14.28%",
            height: 40,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            onClick={() => {
              const nextDate = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                day
              );
              setSelectedDate(day);
              setCurrentDate(nextDate);
              if (typeof onSelectDate === "function") {
                onSelectDate(nextDate);
              }
            }}
            sx={{
              minWidth: 40,
              height: 40,
              borderRadius: "50%",
              backgroundColor: isSelected ? "#605DFF" : "transparent",
              color: isSelected ? "#fff" : "inherit",
              fontSize: "14px",
              fontWeight: 400,
              padding: 0,
            }}
          >
            {day}
          </Button>
        </Box>
      );
    }

    return days;
  };

  return (
    <Box
      elevation={0}
      sx={{
        borderRadius: 3,
        p: 3,
        height: "100%",
        width: "100%",
        margin: "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 3,
        }}
      >
        <IconButton onClick={() => navigateMonth("prev")} sx={{ p: 1 }}>
          <ChevronLeft />
        </IconButton>

        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 500,
            fontSize: "16px",
          }}
        >
          {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
        </Typography>

        <IconButton onClick={() => navigateMonth("next")} sx={{ p: 1 }}>
          <ChevronRight />
        </IconButton>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: 1,
          userSelect: "none",
        }}
      >
        {dayNames.map((day) => (
          <Box
            key={day}
            sx={{
              width: "14.28%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 40,
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{ fontSize: "12px", fontWeight: 500 }}
            >
              {day}
            </Typography>
          </Box>
        ))}
      </Box>
      <Box sx={{ display: "flex", flexWrap: "wrap" }}>
        {renderCalendarDays()}
      </Box>
    </Box>
  );
};

export default Calendar;
